import React, { useEffect, useState } from 'react'
import { Card, CardHeader, Container, Nav, NavItem, NavLink, Navbar, Row, TabContent, TabPane } from 'reactstrap'
import DailyReporting from './DailyReporting';
import Layout from 'HorizontalMenu/Menu';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import VerifierReporting from './VerifierReporting';
import VesselAnalysis from './VesselAnalysis';
import EmissionReport from './EmissionReport';
import ReportGenerationFilters from './ReportGenerationFilters';

const ReportGeneration = () => {
    /** State variables */
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    const [vesselBoolean, setVesselBoolean] = useState(false);
    const [count, setCount] = useState(0);
    const [activeSettingsTab, setActiveSettingsTab] = useState('1');
    /** State variables end */

    /** Change vertical tabs */
    const toggle = (tab: any) => {
        if (activeSettingsTab !== tab) {
            if (tab === '3' || tab === '4') {
                setVesselBoolean(true);
            } else {
                setVesselBoolean(false);
            }
            setActiveSettingsTab(tab);
        }
    }

    /** useEffect start */
    useEffect(() => {
        setCount(count => count + 1);
    }, [VesselID])
    /** useEffect end */

    return (
        <>
            <Layout children={Navbar} />
            <div className="page-content">
                <Container fluid>
                    <Row className='mb-3'>
                        <h4>Custom Report Generation</h4>
                    </Row>
                    <ReportGenerationFilters vesselBoolean={vesselBoolean} count={count} />
                    <Card className='p-0'>
                        <CardHeader className='pb-0'>
                            <Nav tabs className='border-0'>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "1",
                                        })}
                                        onClick={() => {
                                            toggle("1");
                                        }}
                                    >
                                        Daily Reporting
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "2",
                                        })}
                                        onClick={() => {
                                            toggle("2");
                                        }}
                                    >
                                        Verifier Reporting
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "3",
                                        })}
                                        onClick={() => {
                                            toggle("3");
                                        }}
                                    >
                                        Vessel Analysis
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "4",
                                        })}
                                        onClick={() => {
                                            toggle("4");
                                        }}
                                    >
                                        Emission Report
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </CardHeader>
                        <TabContent activeTab={activeSettingsTab}>
                            <TabPane tabId="1" className='margin-3'>
                                <DailyReporting />
                            </TabPane>
                            <TabPane tabId="2" className='margin-3'>
                                <VerifierReporting />
                            </TabPane>
                            <TabPane tabId="3" className='margin-3'>
                                <VesselAnalysis />
                            </TabPane>
                            <TabPane tabId="4" className='margin-3'>
                                <EmissionReport />
                            </TabPane>
                        </TabContent>
                    </Card>
                </Container>
            </div>
        </>
    )
}

export default ReportGeneration